import { defineComponent as _defineComponent } from 'vue'
import IconX from '@/components/svg/x-circle-2.svg?inline';
import IconDownload from '@/components/svg/download-circle.svg?inline';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoicePositionsTableCell',
  props: {
  fieldName: {
    type: String,
    default: ''
  },
  isNarrow: Boolean,
  isReduced: Boolean
},
  setup(__props) {

const props = __props;



const areButtonsVisible = computed(() => (props.isNarrow && !props.isReduced ? props.fieldName === 'date' : props.fieldName === 'name'));

const templateColumns = computed(() => {
  if (!areButtonsVisible.value) {
    return 'auto';
  }
  return props.isReduced ? '1fr auto' : '1fr auto auto';
});


return { __sfc: true,props, areButtonsVisible, templateColumns, IconX, IconDownload }
}

})